import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import SafeAreaLayout from '@/components/layout/SafeAreaLayout'
import { responsiveValueAdapter } from '@/utils'

export const ProcessingKemCard: React.FC = () => {
  const { t } = useTranslation()

  return (
    <BaseView
      className="h-screen flex flex-col overflow-hidden"
      data-component="send-wrapper"
    >
      <SafeAreaLayout isStretch hasNavBar>
        {/* Gradient background */}
        {/* <SendBackground /> */}
        <BaseView
          className="fixed inset-0 z-0"
          style={{
            backgroundImage: 'url(/assets/images/YourCardIsProcessing.png)',
            backgroundSize: 'cover',
            backgroundPosition: '-10% 50%',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        />

        {/* Main content */}
        <BaseView
          flex={1}
          className="relative z-10 flex flex-col overflow-hidden"
          px={12}
          style={{
            paddingTop: 'env(safe-area-inset-top)',
            paddingLeft: 'env(safe-area-inset-left)',
            paddingRight: 'env(safe-area-inset-right)',
            minHeight: 0,
          }}
        >
          <BaseView
            p={20}
            align="center"
            justify="flex-end"
            gap={42}
            flex={1}
            style={{
              marginBottom: responsiveValueAdapter(135, true),
              overflow: 'hidden',
            }}
          >
            {/* Background Image Placeholder */}

            <BaseView gap={16} align="center">
              <BaseText
                fontSize={28}
                fontFamily="semibold"
                color="label.default"
                textAlign="center"
              >
                {t('screens:cards.inProgress')}
              </BaseText>

              <BaseText
                fontSize={16}
                fontFamily="regular"
                color="label.default"
                textAlign="center"
              >
                {t('screens:cards.inProgressDescription')}
              </BaseText>
              {/* <BaseText
              fontSize={16}
              fontFamily="regular"
              color="label.default"
              textAlign="center"
            >
              {t('screens:cards.inProgressDescription2')}
            </BaseText> */}
            </BaseView>
          </BaseView>
        </BaseView>
      </SafeAreaLayout>
    </BaseView>
  )
}
